import { Outlet } from "react-router-dom";
import { CookieConsent } from "@/components/CookieConsent/CookieConsent";
import { FirebaseAuthSync } from "@/components/FirebaseAuthSync";

export function RootLayout() {
  return (
    <FirebaseAuthSync>
      <Outlet />
      <CookieConsent />
    </FirebaseAuthSync>
  );
}
